var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "tr",
    { staticClass: "data-table-filters-row" },
    _vm._l(_vm.items, function ({ field, filter, value }, idx) {
      return _c(
        "td",
        { key: idx },
        [
          filter
            ? _vm._t(
                "default",
                function () {
                  return [
                    filter.control === "text" &&
                    (!value || (value && Object.keys(value).length === 1))
                      ? [
                          _c("FilterText", {
                            attrs: {
                              field: field,
                              value: !value
                                ? null
                                : value[Object.keys(value)[0]],
                              filter: filter,
                              options: _vm.options,
                            },
                            on: { input: _vm.setFilters },
                          }),
                        ]
                      : _vm._e(),
                    filter.control === "select"
                      ? [
                          _c("FilterSelect", {
                            attrs: {
                              field: field,
                              value: !value
                                ? null
                                : value[Object.keys(value)[0]],
                              filter: filter,
                              options: _vm.options,
                            },
                            on: { input: _vm.setFilters },
                          }),
                        ]
                      : _vm._e(),
                    filter.control === "date-range"
                      ? [
                          _c("FilterDateRange", {
                            attrs: {
                              value: {
                                gte: _vm.get(value, "gte", null),
                                lte: _vm.get(value, "lte", null),
                              },
                            },
                            on: {
                              input: ([from, to]) =>
                                _vm.setFilters([
                                  { field, value: from, modifier: "gte" },
                                  { field, value: to, modifier: "lte" },
                                ]),
                            },
                          }),
                        ]
                      : _vm._e(),
                  ]
                },
                { field: field, filter: filter, value: value }
              )
            : _vm._e(),
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }